import { render, staticRenderFns } from "./MorrisCharts.vue?vue&type=template&id=40aeca8b&"
import script from "./MorrisCharts.vue?vue&type=script&lang=js&"
export * from "./MorrisCharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports